import { executeRequest, Request } from '@jfs/network'
import { actionMenuStrings } from '../../src/data/static/strings'
import { RootStore } from '../../src/data/store'
import { dateFormatter, DateFormatTypes, updateEndDateTimeInRequest } from '../util/util'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = ({ data }: any) => {
  const { content, page } = data
  const retData = content?.map((item: any) => {
    return {
      ...item,
      id: item?.transactionId ?? 'NA', //V3 change
      transactionDateTime: `${dateFormatter(item?.transactionDateTime ?? 'NA', DateFormatTypes.DATE_ONLY)}`,
      txnType: item.type ?? 'Transaction',
      merchantName:
        item?.merchantName?.length >= 35
          ? `${item?.merchantName?.toString().substring(0, 35)}...`
          : item?.merchantName ?? 'NA',
    }
  })
  return { page: page, history: retData }
}

const getTokenTransactionHistory = (tokens: any, reqBody: any) => {
  const isCustomRange = RootStore.tokenizationRequests.txnsSelectedDate.dateLabel === actionMenuStrings.customDate
  console.log('isCustomRange vaultTokenTxnsHistory', isCustomRange)
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.vaultTokenTxnsHistory,
    body: isCustomRange
      ? reqBody
      : updateEndDateTimeInRequest(reqBody, RootStore.tokenizationRequests.txnsSelectedDate),
    method: 'POST',
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { getTokenTransactionHistory }
